import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import SwiperCore from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { COLORS } from "../../constants";
import useImagePreload from "../../hooks/useImagePreload";

SwiperCore.use([Navigation, Autoplay]);

const MobileTradeSlideShow = ({ selectedYear, imageUrls }) => {
  const images = imageUrls || [];
  // Only the first slide is preloaded — Swiper mounts every slide upfront, so preloading all of
  // them (as wrapping each in LoadableImage did) fires 100+ concurrent requests per year switch.
  const isFirstImageLoading = useImagePreload(images[0]);

  return (
    <Box sx={{ borderRadius: "2px" }}>
      <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
        <Typography
          variant="h6"
          sx={{
            backgroundColor: COLORS.themeBlack,
            color: COLORS.themeYellow,
            px: 1.5,
            py: 0.5,
            mr: 1.5,
            borderRadius: "2px",
            fontWeight: 500,
            fontSize: "var(--font-size-s)",
          }}
        >
          {selectedYear}
        </Typography>
        <Typography
          variant="h6"
          sx={{
            color: COLORS.darkText,
            textTransform: "uppercase",
            fontWeight: 600,
            fontSize: "var(--font-size-s)",
          }}
        >
          Trade Show
        </Typography>
      </Box>
      {images.length === 0 ? (
        <Typography>No images available for {selectedYear}</Typography>
      ) : isFirstImageLoading ? (
        <Box
          sx={{
            height: "60vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <Swiper
          modules={[Navigation, Autoplay]}
          spaceBetween={50}
          slidesPerView={1}
          navigation
          loop={true}
          autoplay={{
            delay: 3000, // 3 seconds per slide
            disableOnInteraction: true, // Pause on user interaction
          }}
          style={{
            "--swiper-navigation-color": COLORS.white,
            "--swiper-navigation-size": "40px",
          }}
        >
          {images.map((image, index) => (
            <SwiperSlide key={image}>
              <Box
                sx={{
                  position: "relative",
                  width: "100%",
                  height: "60vh",
                  overflow: "hidden",
                }}
              >
                <img
                  src={image}
                  alt={`Trade Show ${selectedYear} - ${index + 1}`}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    borderRadius: "2px",
                  }}
                />
              </Box>
            </SwiperSlide>
          ))}
        </Swiper>
      )}
    </Box>
  );
};

export default MobileTradeSlideShow;
